window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.WarrantyIndex.init());

Sq.Shop.WarrantyIndex = {
  init() {
    if ($('#warranty-index-page').length === 0) {
      return;
    }

    this.getHtml();
    this.bindEvents();
  },

  getHtml() {
    this.$form = $('#warranty-items-form');
    this.$items = $('.line-item');
  },

  bindEvents() {
    this.$form.on('click', '.line-item', (e) => this.onLineItemClick(e));
  },

  onLineItemClick(e) {
    const clickedInput = $(e.target).closest('input').length > 0;
    const clickedLabel = $(e.target).closest('label').length > 0;
    const clickedSelect = $(e.target).closest('select').length > 0;
    if (!clickedInput && !clickedLabel && !clickedSelect) {
      const $item = $(e.currentTarget);
      const $checkbox = $item.find('input[name="selected[]"]');
      const isChecked = $checkbox.prop('checked');
      $checkbox.prop('checked', !isChecked).trigger('change');
    }
  },
};
